import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo } from 'react';
import type { ReadonlyURLSearchParams } from 'next/navigation';
interface UseWaveNavigationOptions {
  readonly basePath: string;
  readonly activeWaveId: string | null;
  readonly setActiveWave: (waveId: string | null, options?: {
    isDirectMessage?: boolean;
  }) => void;
  readonly onHover: (waveId: string) => void;
  readonly prefetchWaveData: (waveId: string) => void;
  readonly searchParams: ReadonlyURLSearchParams | null;
  readonly waveId: string;
  readonly hasTouchScreen: boolean;
}
interface UseWaveNavigationResult {
  readonly href: string;
  readonly isActive: boolean;
  readonly onMouseEnter: (() => void) | undefined;
  readonly onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}
export const useWaveNavigation = t0 => {
  const $ = _c(23);
  const {
    basePath,
    activeWaveId,
    setActiveWave,
    onHover,
    prefetchWaveData,
    searchParams,
    waveId,
    hasTouchScreen
  } = t0;
  let t1;
  if ($[0] !== activeWaveId || $[1] !== searchParams) {
    t1 = activeWaveId ?? searchParams?.get("wave") ?? undefined;
    $[0] = activeWaveId;
    $[1] = searchParams;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const currentWaveId = t1;
  const isDirectMessage = basePath === "/messages";
  let t2;
  bb0: {
    if (currentWaveId === waveId) {
      t2 = basePath;
      break bb0;
    }
    let t3;
    let t4;
    if ($[3] !== basePath || $[4] !== waveId) {
      const params = new URLSearchParams();
      params.set("wave", waveId);
      t3 = basePath;
      t4 = params.toString();
      $[3] = basePath;
      $[4] = waveId;
      $[5] = t3;
      $[6] = t4;
    } else {
      t3 = $[5];
      t4 = $[6];
    }
    t2 = `${t3}?${t4}`;
  }
  const href = t2;
  const isActive = waveId === currentWaveId;
  let t3;
  if ($[7] !== currentWaveId || $[8] !== onHover || $[9] !== prefetchWaveData || $[10] !== waveId) {
    t3 = () => {
      if (waveId === currentWaveId) {
        return;
      }
      onHover(waveId);
      prefetchWaveData(waveId);
    };
    $[7] = currentWaveId;
    $[8] = onHover;
    $[9] = prefetchWaveData;
    $[10] = waveId;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const onMouseEnter = t3;
  let t4;
  if ($[12] !== currentWaveId || $[13] !== isDirectMessage || $[14] !== onMouseEnter || $[15] !== setActiveWave || $[16] !== waveId) {
    t4 = event => {
      if (event.defaultPrevented) {
        return;
      }
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1 || event.button === 2) {
        return;
      }
      event.preventDefault();
      onMouseEnter();
      const nextWaveId = waveId === currentWaveId ? null : waveId;
      setActiveWave(nextWaveId, {
        isDirectMessage
      });
    };
    $[12] = currentWaveId;
    $[13] = isDirectMessage;
    $[14] = onMouseEnter;
    $[15] = setActiveWave;
    $[16] = waveId;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  const onClick = t4;
  const t5 = hasTouchScreen ? undefined : onMouseEnter;
  let t6;
  if ($[18] !== href || $[19] !== isActive || $[20] !== onClick || $[21] !== t5) {
    t6 = {
      href,
      isActive,
      onMouseEnter: t5,
      onClick
    };
    $[18] = href;
    $[19] = isActive;
    $[20] = onClick;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
};